import React, { useState } from 'react';
import { Plus, Minus, HelpCircle } from 'lucide-react';
import { FAQS } from '../mock';

const FAQ = () => {
  const [openId, setOpenId] = useState('q1');

  return (
    <section id="faq" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[12px] font-medium text-slate-700 uppercase tracking-[0.18em]">
              FAQ
            </div>
            <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-semibold tracking-tight text-slate-900">
              Questions,{' '}
              <span className="text-indigo-600">answered.</span>
            </h2>
            <p className="mt-5 text-[15.5px] leading-relaxed text-slate-600">
              Still curious? Ping us at{' '}
              <a className="text-slate-900 underline underline-offset-4" href="#contact">
                hello@scaturasolutions.com.au
              </a>{' '}
              and we’ll come back within one working day.
            </p>
          </div>

          <div className="lg:col-span-8 space-y-3">
            {FAQS.map((f) => {
              const isOpen = openId === f.id;
              return (
                <div
                  key={f.id}
                  className={`rounded-2xl border transition-all duration-300 ${
                    isOpen ? 'border-indigo-200 bg-indigo-50/40 shadow-sm' : 'border-slate-200 bg-white'
                  }`}
                >
                  <button
                    onClick={() => setOpenId(isOpen ? null : f.id)}
                    className="w-full flex items-center gap-4 text-left px-5 py-4"
                  >
                    <span className="flex-none w-9 h-9 rounded-xl bg-white border border-slate-200 flex items-center justify-center">
                      <HelpCircle size={16} className="text-indigo-600" />
                    </span>
                    <span className="flex-1 text-slate-900 font-semibold text-[15.5px]">
                      {f.question}
                    </span>
                    <span className="flex-none text-slate-400">
                      {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-[68px] text-[14.5px] leading-relaxed text-slate-600">
                        {f.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
